import { Accordion, Switch, SwitchProps } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import t from '../theme';

export const StyledAccordionContainer = styled(Accordion)({
    marginBottom: '1.25rem',
    borderRadius: '0.625rem',
    boxShadow: '0 0.125rem 0.375rem 0 #0000001A',
    '&.MuiAccordion-root:before': {
        display: 'none'
    },
    '&.MuiAccordion-root:first-of-type': {
        borderRadius: '0.625rem'
    },
    '&.MuiAccordion-root:last-of-type': {
        borderRadius: '0.625rem'
    }
});

export const StyledInnerAccordion = styled(Accordion)({
    '&.MuiAccordion-root:before': {
        display: 'none'
    }
});

export const StyledGlobalSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(1rem)',
            color: t.palette.globalSwitch.main,
            '& + .MuiSwitch-track': {
                backgroundColor: t.palette.globalSwitch.enabledBg,
                opacity: 1,
                border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: t.palette.globalSwitch.enabledBg
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: t.palette.globalSwitch.main
        }
    },
    '& .MuiSwitch-thumb': {
        margin: '0.188rem',
        boxSizing: 'border-box',
        width: 16,
        height: 16
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: t.palette.globalSwitch.disabledBg,
        opacity: 1
    }
});
